exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.head[data-v-06822698] {\n  margin: 20px 0 0 20px;\n}\n\n", ""]);

// exports
